// remove [no-js] tag from HTML
document.documentElement.classList.remove('no-js');

// globals
import './globals/webpackPublicPath';

// polyfills
import './polyfills/index';

// modules
import 'lazysizes';

import * as siteNavigation from './modules/primary-nav';
siteNavigation.init();

import * as siteSearch from './modules/site-search';
siteSearch.init();

import * as scrollTop from './modules/scroll-top';
scrollTop.init();

import * as activeState from './modules/active-state';
activeState.init();

import * as helpers from './modules/helpers';
helpers.init();

import * as detectDevice from './modules/detect-device';
detectDevice.init();

// import * as year from './modules/500-year';
// year.init();

import * as tooltip from './modules/tooltip';
tooltip.init();

//initialises vue components
import vueComponents from './vue/_index';
vueComponents();

if (document.querySelector('.card-list--slider')) {
  import(/* webpackChunkName: "cardCarousel" */ './modules/card-carousel').then((cardCarousel) => cardCarousel.init());
}

if (document.querySelector('.js-card-carousel')) {
  import(/* webpackChunkName: "carousel" */ './modules/carousel').then((carousel) => carousel.init());
}

if (document.querySelector('#responsive-annotation')) {
  import(
    /* webpackChunkName: "responsiveAnnotation" */ './modules/responsive-annotation'
  ).then((responsiveAnnotation) => responsiveAnnotation.init());
}

if (document.querySelector('.js-accordion')) {
  import(/* webpackChunkName: "accordion" */ './modules/accordion').then((accordion) => accordion.init());
}

if (document.querySelector('.js-jaja-feature-container-accordion')) {
  import(/* webpackChunkName: "accordion" */ './modules/jaja-feature-container-accordion').then((jajaAccordion) =>
    jajaAccordion.init()
  );
}
if (document.querySelector('table:not([class])')) {
  import(/* webpackChunkName: "responsiveTable" */ './modules/responsive-table').then((responsiveTable) =>
    responsiveTable.init()
  );
}

if (document.querySelector('.js-loading')) {
  import(/* webpackChunkName: "loadingPage" */ './modules/loading-page').then((loadingPage) => loadingPage.init());
}

if (document.querySelector('.js-pagination-carousel')) {
  import(/* webpackChunkName: "paginationCarousel" */ './modules/pagination-carousel').then((paginationCarousel) =>
    paginationCarousel.init()
  );
}

if (document.querySelector('.js-list-filter')) {
  import(/* webpackChunkName: "storeFinder" */ './modules/list-filter').then((listFilter) => listFilter.init());
}
if (document.querySelector('.js-table-block')) {
  import(/* webpackChunkName: "table" */ './modules/table').then((table) => table.init());
}

if (document.querySelector('.js-year')) {
  import(/* webpackChunkName: "yearAmend" */ './modules/500-year').then((yearAmend) => yearAmend.init());
}

import * as gtm from './modules/gtm';
gtm.init();

// Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/Static/build/js/service-worker.js');
  });
}
